<template>
  <div>
    <van-nav-bar title="查看发票" left-arrow @click-left="backOrder" />
    <div style="overflow:hidden;width:100%;height:10rem">
      <div style="float:left;width:50%;">
        <img
          src="./../../assets/login-logo.png"
          height="90%"
          width="90%"
        />
      </div>
      <div style="float:right;margin-top:3rem;margin-right:3rem">
        <div>
          <van-button>查看发票</van-button>
        </div>
      </div>
    </div>
    <div :v-model="item">
      <van-cell-group >
        <van-field v-model="item.invoiceheader" maxlength="11" label="发票抬头" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="item.enterpriseTaxNumber" label="企业税号" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="item.billingContent" label="开票内容" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="item.invoiceAmount" label="发票金额" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="item.remarks" label="备注" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="item.email" label="收票邮箱" />
      </van-cell-group>
      <van-cell-group>
        <div style="width:100%;height:6rem;">
          <div style="text-align:center">
              备注：发票开具后不支持内容修改
          </div>
        </div>
      </van-cell-group>
    </div>
  </div>
</template>
<script>
import md5 from "js-md5";
import {
  Button,
  Cell,
  CellGroup,
  Col,
  Dialog,
  Field,
  Form,
  Icon,
  Row,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Toast,
  Divider,
} from "vant";

export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [Divider.name]: Divider,
  },
  data() {
    return {
      hasSendSms: false,
      smsCode: "",
      second: 300,
      mobile: "",
      loginloading: false,
      item:{
        "invoiceheader":"411554454",
        "enterpriseTaxNumber":"4545121545",
        "billingContent":"开票内容",
        "invoiceAmount":"12.23",
        "remarks":"测试测试",
        "email":"112658222@qq.com",
      }
    };
  },
  mounted() {
    // this.loginOrRegister()
  },
  methods: {
    handleSend() {
      let _this = this;
      let _phone = _this.mobile.replace(/\s+/g, "");
      if (_phone) {
        if (/^1([3-9])\d{9}$/.test(_phone)) {
          _this.sendSms();
        } else {
          Toast({
            message: "手机号输入有误",
            position: "middle",
            duration: 2000,
          });
        }
      } else {
        Toast({
          message: "手机号不能为空",
          position: "middle",
          duration: 2000,
        });
      }
    },
    backOrder() {
      this.$router.push("/order");
    },
    sendSms() {
      this.hasSendSms = true;

      this.$axios
        .post("/common/" + this.mobile + "/addNewSmsrecorder")
        .then((data) => {
          if (data.code == 200) {
            Toast(data.message);
            sessionStorage.setItem(
              "checkednum",
              JSON.stringify({
                checkednum: data.data,
                time: Date.now(),
              })
            ); //保存验证码备用
            this.setTimeOut();
          } else {
            Toast(data.message);
          }
        })
        .catch((erro) => {
          reject(erro);
        });

      //})
    },
    setTimeOut() {
      let timer = setTimeout(() => {
        this.setTimeOut();
        if (this.second > 0) {
          this.second--;
        }
      }, 1000);
      if (this.second <= 0) {
        this.hasSendSms = false;
        this.second = 300;
        clearTimeout(timer);
      }
    },
    validator(val) {
      return /^((13\d)|(14[5,7,9])|(15[0-3,5-9])|(166)|(17[0,1,3,5,7,8])|(18[0-9])|(19[8,9]))\d{8}/.test(
        val
      );
    },
    loginOrRegister(vals) {
      var regPattern =
        /^((13\d)|(14[5,7,9])|(15[0-3,5-9])|(166)|(17[0,1,3,5,7,8])|(18[0-9])|(19[8,9]))\d{8}/;
      if (!regPattern.test(this.mobile)) {
        Toast("手机号格式异常");
        return "";
      }
      if (this.mobile === null || this.mobile === "") {
        Toast("请输入手机号");
      }
      let id = sessionStorage.getItem("openId");
      if (id === null || id === "") {
        Toast("openid丢失，请重新关闭当前界面");
        return;
      }
      this.loginloading = true;

      let _check = JSON.parse(sessionStorage.getItem("checkednum"));
      if (!_check) {
        Toast("请获取验证码!");
        return;
      }
      if ((Date.now() - _check.time) / 1000 >= 300) {
        Toast("请重新获取验证码!");
        return;
      }

      if (md5(this.smsCode).toUpperCase() != _check.checkednum) {
        Toast("验证码输入错误!");
        return;
      }

      let _this = this;
      let url = "/common/registerAndLogin";
      setTimeout(() => {
        this.loginloading = false;
      }, 6000);
      return new Promise((resolve, reject) => {
        _this.$axios
          .post(url, {
            memMobileno: this.mobile, // 手机号
            memWxId: sessionStorage.getItem("openId"), // 微信openid
            code: this.smsCode,
          })
          .then((data) => {
            if (data.code == 200) {
              Toast("登录成功");
              localStorage.setItem("accessToken", data.data.token);
              // localStorage.setItem("login_data", JSON.stringify(data.data));
              // sessionStorage.setItem("memPicture",data.data.memPicture);
              sessionStorage.setItem("id", data.data.id);
              this.$router.push({ path: "/home" });
            } else {
              Toast(data.message);
              this.loginloading = false;
            }
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },
  },
};
</script>

<style lang="less">
.button-group {
  // margin: 15px;
  .van-button {
    margin-top: 10px;
  }
}
.van-field__left-icon .van-icon,
.van-field__right-icon .van-icon {
  font-size: 28px;
}
.user {
  &-poster {
    width: 100%;
    display: block;
  }
  .van-field__left-icon {
    margin-right: 24px;
  }
  &-group {
    margin-bottom: 15px;
  }
  .van-cell {
    background-color: #f8f8f8 !important;
  }
  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
// .img1{
//   background-size: 100% 100%;
//   background: url('../../assets/img/banner.png') center center no-repeat;
//   height: 100%;
//   position: fixed;
//   width: 100%
// }
</style>
